module.exports = function UpdateSourceDeltaRequest(cid, path, id, bytes) {
    this.cid = cid;
    this.path = path;
    this.id = id;
    this.bytes = bytes;
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/topic-update/update-source-delta-request.js
// module id = 484
// module chunks = 1